import { render } from "./BatchOrderRow.vue?vue&type=template&id=bdf6e0be&scoped=true"
import script from "./BatchOrderRow.vue?vue&type=script&lang=js"
export * from "./BatchOrderRow.vue?vue&type=script&lang=js"

import "./BatchOrderRow.vue?vue&type=style&index=0&id=bdf6e0be&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdf6e0be"]])

export default __exports__